import { render, staticRenderFns } from "./LandingSales.vue?vue&type=template&id=20fd0d49&scoped=true"
import script from "./LandingSales.vue?vue&type=script&lang=js"
export * from "./LandingSales.vue?vue&type=script&lang=js"
import style0 from "./LandingSales.vue?vue&type=style&index=0&id=20fd0d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd0d49",
  null
  
)

export default component.exports